module.exports = __webpack_public_path__ + "img/logo.8af3b4d5.png";